import intl from "react-intl-universal";

const STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200",
  in_review: "bg-sky-100 text-sky-800 dark:bg-sky-950/40 dark:text-sky-200",
  approved: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200",
  rejected: "bg-rose-100 text-rose-800 dark:bg-rose-950/40 dark:text-rose-200",
};

export const BaasKybStatusBadge = ({
  status = "pending",
  hideWhenApproved = true,
  className = "",
}) => {
  const normalizedStatus = status || "pending";

  if (hideWhenApproved && normalizedStatus === "approved") {
    return null;
  }

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${STATUS_STYLES[normalizedStatus] ?? STATUS_STYLES.pending} ${className}`}
    >
      {intl.get(`baas.instances.kybStatus.${normalizedStatus}`)}
    </span>
  );
};
